<template>
  <v-btn
    :flat="flat"
    :depressed="depressed"
    :outline="outline"
    :href="href"
    :disabled="disabled"
    :color="color"
    :type="type"
    :loading="loading"
    :style="{ color: flat ? color : 'white' }"
    round
    class="ml-0 main-button"
    @click="$emit('click', $event)"
  >
    <slot v-if="!text" />
    <span v-else :style="{ 'text-transform': uppercase ? 'uppercase' : 'initial' }">{{
      text
    }}</span>
  </v-btn>
</template>

<script>
import Vue from 'vue'

const button = {
  props: {
    text: String,
    href: String,
    disabled: Boolean,
    depressed: Boolean,
    outline: Boolean,
    flat: Boolean,
    loading: Boolean,
    uppercase: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: 'primary',
    },
  },
  name: 'main-button',
}

Vue.component('main-button', button)
export default button
</script>

<style scoped>
.main-button {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  text-transform: uppercase;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ffffff;
  /* allow multi-line text */
  white-space: normal !important;
  line-height: 120%;
}

/* v-btn content wrapper - enable wrapping and center text */
.main-button >>> .v-btn__content {
  white-space: normal;
  text-align: center;
}

/* Clamp to 2 lines if text is long */
.main-button >>> .v-btn__content span {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
}
</style>
